class Pagination {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.input = self.elem.querySelector('[data-pagination-input]');
        self.pageUrl = self.elem.getAttribute('data-page-url');

        self.dropdown = self.elem.querySelector('[data-pagination-dropdown]');
        self.dropdownToggle = self.elem.querySelector('[data-pagination-dropdown-toggle]');
        self.onDropdownOutsideClick = self.onDropdownOutsideClick.bind(self);
        self.onDropdownEscape = self.onDropdownEscape.bind(self);
        self.dropdownIsOpen = false;
    }

    init() {
        let self = this;

        self.initGoToPage();
        self.initDropdown();
    }

    initGoToPage() {
        let self = this;

        if(self.input) {
            self.input.addEventListener("keyup", (evt) => {
                if (evt.key === "Enter") {
                    // If the entered number is less than the total number pages and greater than zero
                    if(parseInt(self.input.value) <= parseInt(self.input.getAttribute('max')) && parseInt(self.input.value) > 0) {
                        // Go to the page
                        window.location.href = self.pageUrl + '/p' + self.input.value + window.location.search;
                    } else {
                        self.input.classList.add('is-invalid');
                    }
                }
            });
        }
    }

    initDropdown() {
        let self = this;

        self.dropdownToggle.addEventListener('click', evt => {
            if(self.dropdownIsOpen) {
                self.closeDropdown();
            } else {
                self.openDropdown();
            }
        });
    }

    openDropdown() {
        let self = this;
        
        self.dropdown.classList.add('is-open');

        self.dropdownToggle.setAttribute('aria-expanded', true);
        
        // Add event listeners
        self.addDropdownEventListeners();

        self.dropdownIsOpen = true;
    }

    closeDropdown() {
        let self = this;

        self.dropdown.classList.remove('is-open');

        self.dropdownToggle.setAttribute('aria-expanded', false);

        // Remove event listeners
        self.removeDropdownEventListeners();

        self.dropdownIsOpen = false;
    }

    addDropdownEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onDropdownOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onDropdownEscape);
    }

    removeDropdownEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onDropdownOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onDropdownEscape);
    }

    onDropdownOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        if (evt.target !== self.dropdown && !self.dropdown.contains(evt.target)) {

            // Close the dropdown
            self.closeDropdown();
        }
    }

    onDropdownEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.closeDropdown();
        }
    }
}

export default Pagination;
